var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6877",
    "data-name": "Path 6877",
    d: "M8.546,16.235,5.628,12.767a1,1,0,0,0-1.424,0,1.016,1.016,0,0,0,0,1.437l3.62,4.176a1.007,1.007,0,0,0,1.434,0l8.35-10.962a1.016,1.016,0,0,0,0-1.437,1,1,0,0,0-1.424,0Z",
    transform: "translate(-3.906 -5.681)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.c44f9a72c23777c23d253cd4e9990ea4.svg";
export { ForwardRef as ReactComponent };